const tokenName = "access_token";

/**
 * 获取token
 * @returns {string}
 */
function getToken() {
    return localStorage.getItem(tokenName)
}

/**
 * 设置token
 * @param token
 */
function setToken(token: string) {
    localStorage.setItem(tokenName, token)
}

/**
 * 清空token
 */
function removeToken() {
    localStorage.setItem(tokenName, "")
}

export {
    getToken,
    setToken,
    removeToken
}
